import {
  JOB_STATUS_CLIENT_NAMES,
  JOB_STATUS_COLORS,
  JobBase,
  JobStatus,
  Work,
} from "@project/shared-types";
import { Copy } from "../../components/texts/Copy/Copy";
import { Label } from "../../components/texts/label";
import { Text } from "../../components/texts/text";
import { _colorText, _size, _sizeText } from "../../core/core";
import "./CardJob.css";

export interface JobViewerProps<T extends JobBase> {
  job_data: T;
  work?: Work;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const JobViewer: React.FC<JobViewerProps<JobBase>> = ({
  job_data: job,
  work,
  children,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    onClick?.(e);
    e.stopPropagation();
    e.preventDefault();
  };
  const getStatus = () => {
    if (job.status == JobStatus.DO && job.date_public > Date.now()) {
      return "Запланировано";
    }
    return JOB_STATUS_CLIENT_NAMES[job.status];
  };

  return (
    <>
      <div onClick={handleClick} className="card-job ">
        <div className="card-job-h">
          <div className="card-job-hl">
            <div className="card-job-h-group">
              <Text size={_sizeText.l} color={_colorText.black}>
                Задание
              </Text>
              <Copy value={job.id.toString()}>
                <Text size={_sizeText.l} color={_colorText.neutral}>
                  №{job.view_id}
                </Text>
              </Copy>
            </div>
          </div>
          <div className="card-job-hr">
            <Label size={_size.XS} status={JOB_STATUS_COLORS[job.status]}>
              {getStatus()}
            </Label>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};
